"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.target.client': 'Client',
    'slot.target.coworker': 'Coworker',
    'slot.target.manager': 'Manager',
    'slot.target.self': 'Me',
};
